module.exports = __webpack_public_path__ + "img/mainImg.8725f63f.png";